import { KeycloakTokenParsed } from "keycloak-js";
import { AuthUser } from "@/auth/auth.types";
import { keycloakClient } from "@/auth/keycloak";

const stringOrEmpty = (value: unknown): string =>
    typeof value === "string" ? value : "";

const stringArrayOrEmpty = (value: unknown): string[] => {
    if (!Array.isArray(value)) return [];
    return value.filter((item): item is string => typeof item === "string");
};

const parseUser = (token: KeycloakTokenParsed | undefined): AuthUser | null => {
    if (token === undefined) return null;
    const id = stringOrEmpty(token.sub);
    if (id === "") return null;
    return {
        id,
        email: stringOrEmpty(token.email),
        name: stringOrEmpty(token.name),
        preferredUsername: stringOrEmpty(token.preferred_username),
    };
};

const parseRealmRoles = (token: KeycloakTokenParsed | undefined): string[] => {
    if (token === undefined) return [];
    const realmAccess = token.realm_access;
    if (realmAccess === undefined) return [];
    return stringArrayOrEmpty(realmAccess.roles);
};

const parseClientRoles = (token: KeycloakTokenParsed | undefined): string[] => {
    if (token === undefined) return [];
    const resourceAccess = token.resource_access;
    if (resourceAccess === undefined) return [];
    const clientId = keycloakClient.instance.clientId;
    if (clientId === undefined) return [];
    const entry = resourceAccess[clientId];
    if (entry === undefined) return [];
    return stringArrayOrEmpty(entry.roles);
};

export const authLogic = {
    parseUser,
    parseRealmRoles,
    parseClientRoles,
};
